export const KOEFF = 4;
export const KOEFF_X = 4;
export const KOEFF_Y = 3;
export const FRAME_WIDTH = 5;
export const OFFSET_X = 30;
export const OFFSET_Y = 30;